<template>
  <modal name="addPhoneModal" @before-open="beforeOpen" @before-close="beforeClose" height="auto" width="350px">
    <b-card header-tag="header">
      <div slot="header">
        <h4 class="mb-0 ns_card_header_title">新建手机号</h4>
        <span class="close_btn" @click="$modal.hide('addPhoneModal')">×</span>
      </div>
      <p v-if="error" class="text-danger  text-center">{{ error }}</p>
      <div style="padding: 30px;">
        <b-form-group horizontal label-cols="4" label="手机号" label-for="source">
          <b-form-input id="value" v-model="params.phone_num" type="number"/>
        </b-form-group>
        <b-form-group horizontal label-cols="4" label="市县" label-for="type">
          <b-form-select id="type" v-model="params.county_code" :options="countyCodeOption"
                         @change="getAreaSelectData({county_code: params.county_code})"/>
        </b-form-group>
        <b-form-group horizontal label-cols="4" label="片区" label-for="value">
          <b-form-select id="type" v-model="params.area_code" :options="areaCodeOption"/>
        </b-form-group>
        <b-form-group horizontal label-cols="4" label="手机类型" label-for="type">
          <b-form-radio-group id="radio-group-2" v-model="params.type">
            <b-form-radio :value="0">审核端</b-form-radio>
            <b-form-radio :value="1">播放端</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
      <div slot="footer" class="float-right">
        <button class="btn  secondary_btn mr-3" @click.stop="$modal.hide('addPhoneModal')">取消</button>
        <button class="btn  primary_btn" @click.stop="submit(params)">确定</button>
      </div>
    </b-card>
  </modal>
</template>
<script type="text/javascript">
import { getAreaCodeListByCounty } from '@/api/place'
import { addPhone } from '@/api/phone'

export default {
  name: 'addPhoneModal',
  data () {
    return {
      error: '',
      params: {
        phone_num: '',
        county_code: '',
        area_code: '',
        type: 1
      },
      areaCodeOption: []
    }
  },
  components: {},
  computed: {
    countyCodeOption () {
      let list = []
      this.$store.getters.county_code_list.forEach(item => {
        list.push({ text: item.name, value: item.code })
      })
      return list
    }
    // TODO 最好直接返回所有的市县和对应的片区
    // areaCodeOption(){
    //   let list = [];
    //   this.$store.getters.area_code_list.forEach(item => {
    //     list.push({text: item.name, value: item.code});
    //   });
    //   return list;
    // },
  },
  methods: {
    getAreaSelectData (county_code) {
      getAreaCodeListByCounty(county_code).then(resp => {
        this.areaCodeOption = resp.map(v => {
          return { text: v.name, value: v.code }
        })
      }).catch(error => {
      })
    },
    beforeOpen () {

    },
    beforeClose () {
      this.error = ''
      this.params = {
        phone_num: '',
        county_code: '',
        area_code: '',
        type: 1
      }
    },
    submit (data) {
      this.error = ''
      for (let key in data) {
        if (data[key] === '') {
          this.error = '请填写必要的信息'
          this.$toasted.global.pop_warning(this.error)
          return
        }
      }
      addPhone(data).then(resp => {
        this.$toasted.global.pop_success('创建成功')
        this.$emit('onSucess')
        this.$modal.hide('addPhoneModal')
      }).catch(error => {
        // this.error = '创建失败';
        this.$toasted.global.pop_error('创建失败')
      })
    }
  }

}
</script>
<style lang="scss" scoped>
</style>
